import cn from 'classnames';
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useCallback} from 'react';

import {
    TPredicateExpressionGroupTuple,
    TPredicateExpressionCreatorRef,
    IPredicateExpressionGroupRef,
} from 'features/predicate-expression-form-list';

import {TRuleProp} from '../../api/types'
import {RulesGroup} from './rules-group';

interface IRulesCreatorProps {
    initialExpression?: TRuleProp;
    className?: cn.Argument;
    onRulesChange?: (operands?: TRuleProp[]) => void;
}

export const RulesCreator = forwardRef<TPredicateExpressionCreatorRef, IRulesCreatorProps>(
    ({initialExpression, className, onRulesChange}: IRulesCreatorProps, ref) => {
        const rulesRef = useRef<IPredicateExpressionGroupRef>(null);

        const getValuesToSave = () => rulesRef.current?.getValues() as Promise<TPredicateExpressionGroupTuple>;

        const setExpression = rulesRef.current?.setExpression;

        const validate = useCallback(async () => {
            try {
                await rulesRef.current?.getValues(false);
                return true;
            } catch (e) {
                return false;
            }
        }, []);

        useImperativeHandle(ref, () => ({getValuesToSave, setExpression, validate}));

        useEffect(() => {
            if (initialExpression) setExpression?.(initialExpression);
        }, [initialExpression]);

        return (
            <RulesGroup
                ref={rulesRef}
                initialExpression={initialExpression ?? [{connectBy: 'OR'}]}
                className={className}
                depth={0}
                itemIndex="1"
                onRulesChange={onRulesChange}
            />
        );
    }
);
